import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    openId: localStorage.getItem("openid"),
    host:"http://xcqyzs.asmaia.com/yuanhe"
    //host:"http://192.168.3.61"
  },
  mutations: {
    getId (state,openid) {
      state.openId=openid
    },

  },
  actions:{

  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/store.js